import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { hot } from 'react-hot-loader';
import { withRouter } from 'react-router-dom';
import { compose } from 'ramda';
import { injectIntl } from 'react-intl';

import { KioskHome } from './kioskHome.component';
import { selectCurrentKioskData, selectCurrentKioskExperiences } from '../../../modules/kiosk';
import { AnalyticsActions } from '../../../modules/analytics';

const mapStateToProps = createStructuredSelector({
  kioskData: selectCurrentKioskData,
  experiences: selectCurrentKioskExperiences,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logKioskViewedExperiences: AnalyticsActions.logKioskViewedExperiences,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter,
  injectIntl
)(KioskHome);
